// extracted by mini-css-extract-plugin
export default {"videoContainer":"QRScanner_videoContainer__jo6A9","video":"QRScanner_video__sXPIo"};